module.exports = __webpack_public_path__ + "static/media/landing_0003_f.a697e220.jpg";